import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DashboardComponent } from './dashboard/dashboard.component';
import { MatToolbarModule } from '@angular/material/toolbar'; // import MatToolbarModule
import { MatButtonToggleModule } from '@angular/material/button-toggle'; // import MatButtonToggleModule
import { MatButtonModule } from '@angular/material/button';
import { DashboardRoutingModule } from "./dashboard-routing.module";
import { MatGridListModule } from '@angular/material/grid-list';
import { MatExpansionModule } from '@angular/material/expansion';

@NgModule({
  declarations: [
    DashboardComponent,
  ],
  exports: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    MatToolbarModule,
    MatButtonToggleModule,
    MatButtonModule,
    DashboardRoutingModule,
    MatGridListModule,
    MatExpansionModule,
  ]
})
export class DashboardModule {
}
